import React from 'react';
import { cn } from 'src/tef/components/utils/cn';
import { forwardProps } from 'src/tef/components/utils/forwardProps';
import type { ForwardedHTMLProps } from 'src/tef/components/utils/types';

interface GridContainerProps extends ForwardedHTMLProps {
  children: React.ReactNode;
  className?: string;
  cols?: 1 | 2 | 3 | 4 | 5 | 6 | 12;
  gap?: keyof typeof gapSizes;
}

const gapSizes = {
  xs: 'gap-1',
  sm: 'gap-2',
  md: 'gap-4',
  lg: 'gap-6',
  xl: 'gap-8',
  '2xl': 'gap-10',
};

export const GridContainer = React.forwardRef<HTMLDivElement, GridContainerProps>(
  ({ children, className, cols = 1, gap, ...props }, ref) => {
    const forwardedProps = forwardProps(props);

    const colsClass = `grid-cols-${cols}`;
    const gapClass = gap ? gapSizes[gap] : '';

    return (
      <div ref={ref} className={cn('grid', colsClass, gapClass, className)} {...forwardedProps}>
        {children}
      </div>
    );
  }
);

GridContainer.displayName = 'GridContainer';
